const {abstractResource} = require('./abstractResource')

const service = abstractResource('HISTORY')

const History = {
    ...service('histories'),
}

module.exports = {
    History
}